module.exports = __webpack_public_path__ + "img/close.19314b5f.svg";